"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var configuration_1 = require("../configuration");
var PosterController = (function () {
    function PosterController(posterData, stationData) {
        this._stationData = stationData;
        this._content = [posterData.mall, posterData.station, posterData.infoScreen];
    }
    Object.defineProperty(PosterController.prototype, "products", {
        get: function () {
            return this._content.map(function (item) {
                return item.product.title;
            });
        },
        enumerable: true,
        configurable: true
    });
    PosterController.prototype.getProductTitleByKey = function (key) {
        var stroerItem = _.find(this._content, function (cand) {
            return cand.product.id === key;
        });
        if (stroerItem) {
            return stroerItem.product.title;
        }
        return "";
    };
    PosterController.prototype.getProductKey = function (title) {
        var item = _.find(this._content, function (cand) {
            return cand.product.title === title;
        });
        if (item) {
            return item.product.id.toString();
        }
        return "";
    };
    PosterController.prototype.getStroerMedium = function (type) {
        var stroerMedium = _.find(this._content, (function (candidate) {
            return candidate.product.id === type;
        }));
        if (!stroerMedium) {
            return;
        }
        return stroerMedium;
    };
    PosterController.prototype.getHoursArray = function (type) {
        var stroerMedium = this.getStroerMedium(type);
        if (!stroerMedium) {
            return [];
        }
        var result = [];
        stroerMedium.hours.forEach(function (item) {
            result.push({ id: item.id, title: item.title });
        });
        return result;
    };
    PosterController.prototype.getWeekdaysArray = function (type) {
        var stroerMedium = this.getStroerMedium(type);
        if (!stroerMedium) {
            return [];
        }
        var result = [];
        stroerMedium.weekdays.forEach(function (item) {
            result.push({ id: item.id, title: item.title });
        });
        return result;
    };
    PosterController.prototype.getSpotLengthsArray = function (type) {
        var stroerMedium = this.getStroerMedium(type);
        if (!stroerMedium) {
            return [];
        }
        var result = [];
        stroerMedium.spotlengths.forEach(function (item) {
            result.push({ id: item.id, title: item.title });
        });
        return result;
    };
    PosterController.prototype.getRegionsArray = function (type) {
        var stroerMedium = this.getStroerMedium(type);
        if (!stroerMedium) {
            return [];
        }
        var result = [];
        stroerMedium.regions.forEach(function (item) {
            result.push({ id: item.id, title: item.title });
        });
        return result;
    };
    PosterController.prototype.getLandscape = function (type, id) {
        if (!this._stationData[type.toLowerCase()]) {
            return;
        }
        return _.get(this._stationData[type.toLowerCase()][id], "landscape");
    };
    PosterController.prototype.getPortrait = function (type, id) {
        if (!this._stationData[type.toLowerCase()]) {
            return;
        }
        return _.get(this._stationData[type.toLowerCase()][id], "portrait");
    };
    PosterController.prototype.getCombiGroupMembers = function (type, id) {
        var stroerItem = this.getStroerMedium(type);
        if (!stroerItem.combiGroups) {
            return undefined;
        }
        var result = undefined;
        stroerItem.combiGroups.forEach(function (combiGroup) {
            combiGroup.members.forEach(function (member) {
                if (member === id) {
                    result = combiGroup;
                }
            });
        });
        return result;
    };
    PosterController.getComponentsFromMediumKey = function (mediumKey) {
        var split = mediumKey.split("_");
        var expectedSplitLength = 5;
        if (split.length === expectedSplitLength) {
            var typeIndex = 4;
            var hourIndex = 1;
            var weekDayIndex = 2;
            var spotLengthIndex = 3;
            var regionIndex = 4;
            var type = split[0].toString().substr(typeIndex);
            var base = 10;
            var hour = parseInt(split[hourIndex], base);
            var weekDay = parseInt(split[weekDayIndex], base);
            var spotLength = parseInt(split[spotLengthIndex], base);
            var region = parseInt(split[regionIndex], base);
            return { type: type, hour: hour, weekDay: weekDay, spotLength: spotLength, region: region };
        }
        return undefined;
    };
    PosterController.prototype.getTitlesFromIndexes = function (mediumKey) {
        var indexes = PosterController.getComponentsFromMediumKey(mediumKey);
        if (indexes) {
            var type = indexes.type;
            return {
                type: type,
                hour: this.getHourTitle(mediumKey),
                weekDay: this.getWeekDayTitle(mediumKey),
                spotLength: this.getSpotLengthTitle(mediumKey),
                region: this.getRegionTitle(mediumKey)
            };
        }
        return undefined;
    };
    PosterController.prototype.getHourTitle = function (mediumKey) {
        var indexes = PosterController.getComponentsFromMediumKey(mediumKey);
        if (indexes) {
            var type = indexes.type;
            var hoursArr = this.getHoursArray(type);
            var hour = _.find(hoursArr, function (cand) {
                return cand.id === indexes.hour;
            });
            return _.get(hour, "title");
        }
        return undefined;
    };
    PosterController.prototype.getWeekDayTitle = function (mediumKey) {
        var indexes = PosterController.getComponentsFromMediumKey(mediumKey);
        if (indexes) {
            var type = indexes.type;
            var hoursArr = this.getWeekdaysArray(type);
            var hour = _.find(hoursArr, function (cand) {
                return cand.id === indexes.weekDay;
            });
            return _.get(hour, "title");
        }
        return undefined;
    };
    PosterController.prototype.getRegionTitle = function (mediumKey) {
        var indexes = PosterController.getComponentsFromMediumKey(mediumKey);
        if (indexes) {
            var type = indexes.type;
            var hoursArr = this.getRegionsArray(type);
            var hour = _.find(hoursArr, function (cand) {
                return cand.id === indexes.region;
            });
            return _.get(hour, "title");
        }
        return undefined;
    };
    PosterController.prototype.getSpotLengthTitle = function (mediumKey) {
        var indexes = PosterController.getComponentsFromMediumKey(mediumKey);
        if (indexes) {
            var type = indexes.type;
            var hoursArr = this.getSpotLengthsArray(type);
            var hour = _.find(hoursArr, function (cand) {
                return cand.id === indexes.spotLength;
            });
            return _.get(hour, "title");
        }
        return undefined;
    };
    PosterController.prototype.getIndexFromTitle = function (type, key, title) {
        var array;
        switch (key) {
            case "hour":
                array = this.getHoursArray(type);
                break;
            case "weekday":
                array = this.getWeekdaysArray(type);
                break;
            case "spotlength":
                array = this.getSpotLengthsArray(type);
                break;
            case "region":
                array = this.getRegionsArray(type);
                break;
            default:
                configuration_1.PlanConfiguration.logger.warn("WARNING! getIndexFromTitle - key + " + key + "not found!");
                return undefined;
        }
        var result = _.find(array, function (cand) {
            return cand.title === title;
        });
        return _.get(result, "id");
    };
    PosterController.generateNewMediumKey = function (oldKey, kind, newValue) {
        var split = oldKey.split("_");
        var splitPos;
        var hourIndex = 1;
        var weekDayIndex = 2;
        var spotLengthIndex = 3;
        var regionIndex = 4;
        switch (kind) {
            case "hour":
                splitPos = hourIndex;
                break;
            case "weekday":
                splitPos = weekDayIndex;
                break;
            case "spotlength":
                splitPos = spotLengthIndex;
                break;
            case "region":
                splitPos = regionIndex;
                break;
            default:
                configuration_1.PlanConfiguration.logger.warn("WARNING! generateNewMediumKey - kind + " + kind + " not found!");
                return "";
        }
        split[splitPos] = newValue;
        var newKey = split.join("_");
        return newKey;
    };
    PosterController.generateKeyFromBrowserItem = function (posterItem) {
        return "SSTR"
            + posterItem.product
            + "_" + posterItem.hour
            + "_" + posterItem.weekday
            + "_" + posterItem.spotlength
            + "_" + posterItem.region;
    };
    return PosterController;
}());
exports.PosterController = PosterController;
//# sourceMappingURL=posterController.js.map


//////////////////
// WEBPACK FOOTER
// ./buildForProduction/datalayer/posterController.js
// module id = 19
// module chunks = 0